// Sizes every pill in an .in-page-subnav to the width of its widest sibling.
//
// This can't be done in CSS alone: sizing every pill to "however wide the
// widest label needs" and letting the row wrap onto a second line when it
// doesn't fit are two things CSS can give you separately (grid-auto-columns:
// 1fr for the first, flex-wrap for the second) but not together - a 1fr grid
// track doesn't wrap, so a row that no longer fits the shared width scrolls
// horizontally instead of reflowing. Measuring the widest label and writing
// it back as a plain flex-basis avoids that: flex-wrap already knows how to
// reflow a row of fixed-width items, so it just works once every pill has an
// actual pixel value rather than a CSS sizing keyword.
export function initInPageSubnav(): void {
    const navs = document.querySelectorAll<HTMLElement>('.in-page-subnav');
    if (!navs.length) {
        return;
    }

    const equalize = (nav: HTMLElement) => {
        const links = Array.from(nav.querySelectorAll<HTMLElement>('.in-page-subnav__link'));
        if (links.length < 2) {
            return;
        }

        // Clear before measuring, so a width this function set on a previous
        // pass isn't read back as if it were the label's natural size - that
        // would make the shared width ratchet up (or never shrink back down)
        // across resizes instead of tracking the widest label's real size.
        nav.style.removeProperty('--subnav-pill-width');
        const widest = Math.max(...links.map(link => link.getBoundingClientRect().width));
        nav.style.setProperty('--subnav-pill-width', `${Math.ceil(widest)}px`);
    };

    const equalizeAll = () => navs.forEach(equalize);
    equalizeAll();

    // btn-lg-pill's own padding and font size step up at the lg breakpoint, so
    // a label's natural width - and therefore the shared width - changes there
    // too, not only when items wrap onto a new row.
    let resizeTimer: number;
    window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(equalizeAll, 150);
    });
}
